import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { formatDateWithDashes, formatTime } from "../../../utils/helper";
import ShipmentDocuments from "../../shipment-history/shipmentDocuments";

import pdf_icon from "../../../assets/icons/new_icon/pdf_icon.svg";
import {
  getItemsDetails,
  getItemsDocs,
  getItemsHistory,
} from "../../../api/lms";
import GeneralInfo from "./consolidationDetail/generalInfo";
import ItemsListing from "./consolidationDetail/ItemListing";
import HistoryListing from "./consolidationDetail/historyListing";
const ConsolidationDetail = () => {
  const location = useLocation();
  const [itemData, setItemData] = useState<any>();
  const [itemHistory, setItemHistory] = useState<any>();
  const [itemDocs, setItemDocs] = useState<any>();
  const consolidationId = new URLSearchParams(location.search).get("consolidation_no");
  function getItemsDetail(id: string) {
    getItemsDetails(id)
      .then((response) => {
        if (response?.data?.is_error === false) {
          setItemData(response?.data?.content);
        }
      })
      .catch((e) => {});
  }
  function getItemHistory(id: string) {
    getItemsHistory(id)
      .then((response) => {
        if (response?.data?.is_error === false) {
          setItemHistory(response?.data?.content);
        }
      })
      .catch((e) => {});
  }
  function getItemDoc(id: string) {
    getItemsDocs(id)
      .then((response) => {
        if (response?.data?.is_error === false) {
          setItemDocs(response?.data?.content);
        }
      })
      .catch((e) => {});
  }
  useEffect(() => {
    if (consolidationId) {
      getItemsDetail(consolidationId);
      getItemDoc(consolidationId);
    }
  }, []);

  return (
    <div className="container-fluid my-4">
      <div className="d-flex justify-content-between align-items-center">
        <div className="my-auto">
          <nav className="my-auto d-flex " aria-label="breadcrumb">
            <ol className="breadcrumb my-auto   align-items-center">
              <li className="breadcrumb-item">
                <Link
                  className="link-no-style"
                  to={"/app/warehouse/consolidation"}
                >
                  Consolidation
                </Link>
              </li>
              <li
                className="breadcrumb-item active"
                aria-current="page"
                id="shipment_id_breadcrummb"
              >
                {consolidationId}
              </li>
              <span className="badge rounded-pill" id="shipment_status">
                Delivered
              </span>
            </ol>
          </nav>
          <small className="createdby" id="created_text">
            Created by <span id="username">{itemData?.username}</span> on{" "}
            <span id="created_date">
              {`${formatDateWithDashes(
                new Date(itemData?.creation_date)
              )} ${formatTime(itemData?.creation_date)}`}
            </span>
          </small>
        </div>

        <div className="d-flex my-auto text-end">
          <button
            className="p-2 text-white report_btn align-items-center d-flex gap-1"
            style={{ marginRight: 5 }}
            onClick={() => {}}
          >
            <img src={pdf_icon} />
            <span>Download PDF</span>
          </button>
        </div>
      </div>

      <div className="row mt-4">
        <div className="col-sm-12 col-md-12 d-flex flex-column">
          <div className="flex-grow-1 d-flex flex-column">
            <GeneralInfo data={itemData} />
          </div>
        </div>
      </div>
      {consolidationId && (
        <div className="row mt-4">
          <div className="col-sm-12">
            <ItemsListing
              data={() => {}}
              shipmentId={consolidationId}
              setShowAddShipmentDocModal={() => {}}
              fetchDocs={() => {
                // getShipmentDocs(shipmentId);
              }}
            />
          </div>
        </div>
      )}
      {consolidationId && (
        <div className="row mt-4 mb-5">
          <div className="col-sm-12 mb-5">
            <HistoryListing
              data={() => {}}
              shipmentId={consolidationId}
              setShowAddShipmentDocModal={() => {}}
              fetchDocs={() => {
                // getShipmentDocs(shipmentId);
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ConsolidationDetail;
